import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_statistic_article = _resolveComponent("the-statistic-article")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { style: {"padding-top":"65px"} }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_content, { style: { background: '#fff', padding: '24px', margin: 0, minHeight: '280px' } }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_the_statistic_article)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_TheFooter)
    ]),
    _: 1
  }))
}